// Croatian

const lang = {
  gateMediaPreviewHeader: 'Moglo bi vam se svidjeti i',
  loadmore: 'Prikaži više',
  nextMedia: 'Sljedeći medij',
  previousMedia: 'Prethodni medij',
  closePost: 'Zatvori objavu',
  nextPost: 'Sljedeća objava',
  previousPost: 'Prethodna objava',
  outOfStock: 'Nema na skladištu',
  numberOfReviews(n) {
    if (n % 10 === 1 && n % 100 !== 11) {
      return 'recenzija'
    }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 'recenzije' : 'recenzija'
  },
  reportFormField: 'Unesite poruku',
  reportPost: 'Prijavi objavu',
  reportFormTitle: 'Želite li prijaviti ovu sliku?',
  reportFormDetails:
    'Ako smatrate da je slika neprikladna, nezakonita i da se njome krše nečija prava, možete prijaviti sadržaj. Ako prijavite sliku/tekst, moderatori sadržaja bit će obaviješteni i poduzet će se odgovarajuće mjere.',
  reportFormMessagePlaceholder: 'Navedite razlog vaše prijave',
  reportFormMessageLabel: 'Poruka',
  reportFormEmailLabel: 'Vaša adresa e-pošte',
  reportFormSubmitButtonText: 'Pošalji prijavu',
  reportFormCancelButtonText: 'Odustani',
  reportFormSentTitle: 'Hvala na izvješću!',
  reportFormSentCloseButtonText: 'Zatvori',
  cardAndTileAriaLabel: 'U nastavku je popis objava s računa na različitim društvenim mrežama',
  carouselAriaLabel:
    'U nastavku je vrtuljak carousel s objavama na računima na različitim društvenim mrežama',
  singleAriaLabel: 'Ispod je objava s računa na društvenoj mreži',
  poweredBy: 'Omogućuje Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` published at ${date}` : ''
    const createdByString = userName ? ` by ${userName}` : ''
    return `Photo${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Učitajte svoje medije',
  openTheGate: 'Otvorite dijaloški okvir',
}

export default lang
